import { project } from '../config/project.js';

let gaReady = false;

function isProdHost() {
  const host = typeof location !== 'undefined' ? location.hostname : '';
  return host === 'livingatcornerstone.ca' || host === 'www.livingatcornerstone.ca';
}

/** Ensure gtag + GA4 config exist (index.html also injects on prod). */
export function initAnalytics() {
  const id = project.analytics.ga4Id || project.analytics.gtmId;
  if (!id || gaReady) return;
  if (!isProdHost() && !import.meta.env.PROD) return;

  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  const already =
    !!document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${id}"]`) ||
    !!document.querySelector(`script[src*="gtag/js?id=${id}"]`);

  if (!already) {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    window.gtag('js', new Date());
    window.gtag('config', id, { anonymize_ip: true });
  }

  gaReady = true;
}

export function track(eventName, params = {}) {
  if (!eventName) return;
  // Strip accidental PII keys
  const safe = { ...params };
  ['email', 'phone', 'firstName', 'lastName', 'name', 'user_email', 'notes'].forEach((k) => {
    delete safe[k];
  });

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...safe,
  });

  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, safe);
  }

  if (import.meta.env.DEV) {
    console.info('[analytics]', eventName, safe);
  }
}

export function gtmSnippet() {
  return project.analytics.gtmId || project.analytics.ga4Id || '';
}
